import React, { Component } from 'react';
import _ from 'lodash';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Rating } from 'material-ui-rating';
import TextField from 'material-ui/TextField';
import { ToggleStar, ToggleStarBorder } from 'material-ui/svg-icons';

import { HELPERS } from '../config/constants';
import {
  submitResponse,
  updateQuiz,
  updateDashboardCurrentQuiz,
  updateStatAttribute,
  updateDashboardQuestionCount,
  setCurrent,
  updateDashboard,
  changeState
} from '../actions/index';

import QbankButton from '../components/QbankButton';
import '../styles/Quiz.css';

const styles = {
  button: { width: '140px', height: '35px', fontSize: '13px' },
  mobileButton: { width: '88px', height: '30px', fontSize: '8px' }
};

const focusNotes = textArea => (textArea ? textArea.focus() : null);

class QuizNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timer: new Date().getTime()
    };

    this.submit = this.submit.bind(this);
    this.nextQuestion = this.nextQuestion.bind(this);
    this.onRatingChange = this.onRatingChange.bind(this);
    this.onRatingNotesChange = this.onRatingNotesChange.bind(this);
    this.saveNotes = _.debounce(this.saveNotes.bind(this), 1000);
    this.onKeyDown = _.debounce(this.onKeyDown, 75, {
      leading: true,
      trailing: false
    }).bind(this);
  }

  componentWillMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  onKeyDown(e) {
    const { answered, optionSelected } = this.props;
    if (optionSelected) {
      switch (e.key) {
        case '1':
          !answered
            ? this.submit(parseInt(e.key))
            : this.onRatingChange(parseInt(e.key));
          break;
        case '2':
          !answered
            ? this.submit(parseInt(e.key))
            : this.onRatingChange(parseInt(e.key));
          break;
        case '3':
          !answered
            ? this.submit(parseInt(e.key))
            : this.onRatingChange(parseInt(e.key));
          break;
        case '4':
          answered ? this.onRatingChange(parseInt(e.key)) : null;
          break;
        case '5':
          answered ? this.onRatingChange(parseInt(e.key)) : null;
          break;
        case 'Enter':
          answered ? this.nextQuestion() : null;
          break;
        default:
      }
    }
  }

  componentWillReceiveProps(next) {
    const {
      answered,
      currentQuestionIndex,
      rating,
      setCurrent,
      time,
      updateQuiz
    } = this.props;

    if (currentQuestionIndex !== next.currentQuestionIndex) {
      if (!answered) {
        const timerValue = this.state.timer;
        this.setState({ timer: new Date().getTime() }, () => {
          updateQuiz(
            HELPERS.UPDATE_OBJECT(
              { time: time + (new Date().getTime() - timerValue) },
              currentQuestionIndex
            )
          );
        });
      } else {
        this.setState({ timer: new Date().getTime() });
      }
    }

    setCurrent();
  }

  onRatingChange(rating) {
    const {
      updateQuiz,
      currentQuestionIndex,
      updateStatAttribute
    } = this.props;

    updateQuiz(HELPERS.UPDATE_OBJECT({ rating }, currentQuestionIndex));
    updateStatAttribute({ rating });
  }

  submit(confidence) {
    const {
      updateQuiz,
      questionId,
      currentQuestionIndex,
      submitResponse,
      correctOptionIndex,
      selectedOptionIndex,
      time,
      updateDashboardQuestionCount
    } = this.props;
    const timerValue = this.state.timer;

    const updateArgs = [
      HELPERS.UPDATE_OBJECT(
        {
          answered: true,
          confidence,
          time: time + (new Date().getTime() - timerValue)
        },
        currentQuestionIndex
      ),
      HELPERS.UPDATE_OBJECT(
        { explanationVisible: true },
        currentQuestionIndex,
        selectedOptionIndex
      )
    ];

    if (correctOptionIndex > -1) {
      updateArgs.push(
        HELPERS.UPDATE_OBJECT(
          { explanationVisible: true },
          currentQuestionIndex,
          correctOptionIndex
        )
      );
    }

    updateStatAttribute({ confidence });
    updateQuiz(...updateArgs);

    if (correctOptionIndex === selectedOptionIndex) {
      updateDashboardQuestionCount(questionId);
    }
    submitResponse().then(() => {
      setTimeout(this.props.updateDashboardCurrentQuiz, 300);
      this.props.updateDashboard();
    });
  }

  // static focusRatingNotesField(field) {
  //   field ? setTimeout(() => field.focus(), 200) : null;
  // }

  onRatingNotesChange(ratingNotes) {
    const { updateQuiz, currentQuestionIndex } = this.props;
    this.saveNotes(ratingNotes);
    updateQuiz(
      HELPERS.UPDATE_OBJECT(
        { currentRatingNotesValue: ratingNotes, ratingNotes },
        currentQuestionIndex
      )
    );
  }

  nextQuestion() {
    const { nextIndex, updateQuiz } = this.props;

    updateQuiz(HELPERS.UPDATE_OBJECT({ currentQuestionIndex: nextIndex }));
  }

  saveNotes(ratingNotes) {
    const { updateStatAttribute } = this.props;
    updateStatAttribute({ ratingNotes });
  }

  render() {
    const { optionSelected, answered, finished, rating } = this.props;

    const isMobile = window.innerWidth < 1000;

    return (
      <div className="submit-section">
        {!answered ? (
          <div className="submit-row">
            <div
              className={`submit-button-row${
                !optionSelected ? ' row-hide' : ''
              }`}
            >
              <QbankButton
                label="I'M SURE"
                style={isMobile ? styles.mobileButton : styles.button}
                onClick={() => this.submit(1)}
              />
              <QbankButton
                className="confidence-mid"
                label="KIND OF SURE"
                style={isMobile ? styles.mobileButton : styles.button}
                onClick={() => this.submit(2)}
              />
              <QbankButton
                className="confidence-low"
                label="JUST GUESSING"
                style={isMobile ? styles.mobileButton : styles.button}
                onClick={() => this.submit(3)}
              />
            </div>
          </div>
        ) : (
          <div className="bottom-row-wrapper">
            {!finished ? (
              <div>
                <div className="next-row">
                  <div className="rating">
                    <p>RATE THIS QUESTION:</p>
                    <Rating
                      value={rating || 0}
                      max={5}
                      onChange={this.onRatingChange}
                      className="rating-group"
                      iconNormal={<ToggleStarBorder color="#DCDFDB" />}
                      iconHovered={<ToggleStarBorder color="#666" />}
                      iconFilled={<ToggleStar color="#666" />}
                    />
                  </div>
                  <div className="next-wrapper">
                    <QbankButton
                      label="NEXT"
                      style={isMobile ? styles.mobileButton : styles.button}
                      onClick={this.nextQuestion}
                    />
                  </div>
                </div>
                {rating ? (
                  <div className="rating">
                    <p>LEAVE FEEDBACK:</p>
                    <TextField
                      value={this.props.ratingNotes || ''}
                      multiLine
                      rowsMax={5}
                      onChange={(e, val) => this.onRatingNotesChange(val)}
                      underlineFocusStyle={{ borderBottomColor: '#444' }}
                      floatingLabelFocusStyle={{ color: '#444' }}
                      onFocus={() =>
                        document.removeEventListener(
                          'keydown',
                          this.onKeyDown,
                          false
                        )
                      }
                      onBlur={() =>
                        document.addEventListener(
                          'keydown',
                          this.onKeyDown,
                          false
                        )
                      }
                    />
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="finished-row">
                <QbankButton
                  label="DASHBOARD"
                  style={isMobile ? styles.mobileButton : styles.button}
                  onClick={() =>
                    this.props.changeState('dashboard', { fromQuiz: true })
                  }
                />
                <QbankButton
                  className="secondary finish-new"
                  label="NEW QUIZ"
                  style={isMobile ? styles.mobileButton : styles.button}
                  onClick={() => this.props.changeState('init', { skip: true })}
                />
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const questions = state.quiz.questions;
  const currentQuestionIndex = state.quiz.currentQuestionIndex;
  const question = state.quiz.questions[state.quiz.currentQuestionIndex];

  return {
    questionId: question.id,
    finished:
      questions.reduce(
        (total, question) => total + (question.answered ? 1 : 0),
        0
      ) === questions.length,
    nextIndex: questions.reduce(
      (_nextIndex, o, index) =>
        _nextIndex !== currentQuestionIndex
          ? _nextIndex
          : !questions[(currentQuestionIndex + 1 + index) % questions.length]
              .answered
            ? (currentQuestionIndex + 1 + index) % questions.length
            : currentQuestionIndex,
      currentQuestionIndex
    ),
    answered: question.answered,
    optionSelected: question.selectedOptionIndex >= 0,
    currentQuestionIndex: state.quiz.currentQuestionIndex,
    correctOptionIndex: question.options.reduce(
      (correctIndex, option, index) =>
        correctIndex > -1 ? correctIndex : option.correctOption ? index : -1,
      -1
    ),
    selectedOptionIndex: question.selectedOptionIndex,
    rating: question.rating,
    viewOnly: state.quiz.viewOnly,
    time: question.time,
    ratingNotes: question.currentRatingNotes || question.ratingNotes
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      submitResponse,
      updateDashboardCurrentQuiz,
      updateDashboardQuestionCount,
      updateQuiz,
      updateStatAttribute,
      setCurrent,
      updateDashboard,
      changeState
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(QuizNav);



// WEBPACK FOOTER //
// ./src/containers/QuizNav.js